import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Политика конфиденциальности</h1>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
        <p className="mb-4">
          Настоящая политика конфиденциальности определяет порядок обработки и защиты персональных данных ООО "АЙТИ ДЖОЙ" (далее – Оператор).
        </p>
        <p className="mb-4">
          Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">2. Основные понятия</h2>
        <ul className="list-disc pl-6 mb-4">
          <li className="mb-2">Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу;</li>
          <li className="mb-2">Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными;</li>
          <li className="mb-2">Конфиденциальность персональных данных – обязательное для соблюдения требование не допускать их распространения без согласия субъекта персональных данных.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">3. Сбор и использование информации</h2>
        <p className="mb-4">
          Мы собираем информацию, которую вы предоставляете нам при:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li className="mb-2">Заполнении форм обратной связи</li>
          <li className="mb-2">Подписке на рассылку</li>
          <li className="mb-2">Регистрации на сайте</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">4. Защита информации</h2>
        <p className="mb-4">
          Мы принимаем необходимые организационные и технические меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">5. Передача информации третьим лицам</h2>
        <p className="mb-4">
          Мы не передаем ваши персональные данные третьим лицам, за исключением случаев, предусмотренных законодательством Российской Федерации.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">6. Изменения в политике конфиденциальности</h2>
        <p className="mb-4">
          Мы оставляем за собой право вносить изменения в настоящую политику конфиденциальности. При внесении изменений в актуальной редакции указывается дата последнего обновления.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">7. Контактная информация</h2>
        <p className="mb-4">
          Если у вас есть вопросы по поводу нашей политики конфиденциальности, пожалуйста, свяжитесь с нами:
        </p>
        <ul className="list-disc pl-6">
          <li className="mb-2">Email: mail@itjoy.space</li>
          <li className="mb-2">Телефон: +7 914 545 7168</li>
          <li className="mb-2">Адрес: г. Хабаровск, ул. Пионерская, д. 1 - 210</li>
        </ul>
      </section>

      <p className="text-sm text-gray-600">
        Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
      </p>
    </div>
  );
};

export default PrivacyPolicy; 